'use client';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { SubCategory } from '@/graphql/queries/pages/central-de-ajuda/types';
import { ChevronRightIcon } from '@/icons';
import colors from '@/theme/colors';
import { routes } from '@/utils/routes';
import { Select } from '@axa/design-system';

export const SubCategoriesMenu = ({
  subcategories,
  categorySlug
}: {
  subcategories: SubCategory[] | null;
  categorySlug: string;
}) => {
  const { push } = useRouter();
  if (!subcategories) return null;
  return (
    <>
      <div className="px-6 lg:hidden">
        <Select
          placeholder="Selecione uma subcategoria"
          searchable={false}
          options={subcategories.map((item) => ({
            label: item.title,
            value: item.slug
          }))}
          onChange={(item) => {
            const slug = item?.value as string;
            push(routes.helpCenterSubject(categorySlug, slug));
          }}
        />
      </div>

      <ul className="hidden w-full flex-col gap-4 px-6 lg:flex">
        {subcategories.map((item) => (
          <li key={item.id}>
            <Link
              href={routes.helpCenterSubject(categorySlug, item.slug)}
              className="flex w-full justify-between text-grey-800"
            >
              {item.title}
              <ChevronRightIcon fill={colors.blue[500]} />
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
};
